import {apiUserLink} from "@pg-mono/rp-api-routes";
import {DEFAULT_EMAIL_VERIFICATION_ERROR, EmailVerificationResponse, VERIFICATION_API_DEFAULT_ERROR} from "@pg-rp/email-with-verification";

import {rpApi} from "../../app/api/rp_api";

const emailVerificationApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        verifyEmail: builder.query<EmailVerificationResponse, {email: string}>({
            query: (params) => {
                return {
                    url: apiUserLink.validators.email,
                    params
                };
            },
            transformErrorResponse: (response) => {
                if (response.status === 400) {
                    return {data: {message: DEFAULT_EMAIL_VERIFICATION_ERROR}, status: 400};
                }
                if (response.status === 429) {
                    return {data: {message: VERIFICATION_API_DEFAULT_ERROR}, status: 429};
                }
                if (response.status === 502 || response.status === 504) {
                    return {data: {message: VERIFICATION_API_DEFAULT_ERROR}, status: response.status};
                }
                if (response.status === 503) {
                    return {data: {message: VERIFICATION_API_DEFAULT_ERROR}, status: 503};
                }
                return response.data;
            },
            keepUnusedDataFor: 3600
        })
    })
});

export const {useVerifyEmailQuery} = emailVerificationApi;
